export default function SvnLogo({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl md:text-5xl",
    xl: "text-6xl md:text-8xl",
  };
  return (
    <div
      className={`font-display font-black tracking-tighter inline-flex items-baseline gap-0.5 ${sizes[size]} ${className}`}
      data-testid="svn-logo"
    >
      <span className="text-gold">S</span>
      <span className="text-svn-red">V</span>
      <span className="text-white">N</span>
      {size === "lg" || size === "xl" ? (
        <span className="ml-3 font-body font-medium text-[0.35em] tracking-[0.4em] text-white/60 uppercase self-center">
          Network
        </span>
      ) : null}
    </div>
  );
}
